var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "10px",
    height: "11px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(19, 194, 194)",
    d: "M9.444,11.000 L0.555,11.000 C0.249,11.000 -0.000,10.754 -0.000,10.450 C-0.000,10.146 0.249,9.900 0.555,9.900 L9.444,9.900 C9.751,9.900 10.000,10.146 10.000,10.450 C10.000,10.754 9.751,11.000 9.444,11.000 L9.444,11.000 L9.444,11.000 ZM3.333,8.800 L1.111,8.800 C0.804,8.800 0.555,8.553 0.555,8.250 L0.555,6.049 C0.555,5.903 0.614,5.764 0.718,5.660 L6.274,0.160 C6.491,-0.055 6.842,-0.055 7.059,0.160 L9.282,2.360 C9.499,2.575 9.499,2.923 9.282,3.138 L3.726,8.639 C3.622,8.742 3.481,8.800 3.333,8.800 L3.333,8.800 ZM1.667,7.700 L3.103,7.700 L8.103,2.749 L6.667,1.326 L1.667,6.277 L1.667,7.700 L1.667,7.700 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.11ed73744568732c00f43d6ca6afdd99.svg";
export { ForwardRef as ReactComponent };